<template>
    <div class="mb-4">
        <Link class="link text-[14px]" :href="$page.props.urlPrev">
            <div class="flex items-center gap-2">
                <div class="">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="h-4 w-4"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
                        />
                    </svg>
                </div>
                <div class="">{{ linkText }}</div>
            </div>
        </Link>
    </div>
</template>
<script>
export default {
    name: "BackNavButton",
    props: {
        linkText: {
            type: String,
            default: "Go Back",
        },
    },
};
</script>
